import { useTranslation } from 'react-i18next'

import { FeedbackCard } from '../../components'

export const VerifyEmail: React.FC = () => {
  const { t } = useTranslation('login')
  return <FeedbackCard title={t('verifyEmailPage.title')} showLoginText={false} />
}
